<!-- To be filled out when we get more content -->
<footer>
  <ng-content></ng-content>
</footer>
